import { useState } from "react";
import { ReactComponentPropsBase } from "../../base-props/ReactComponentPropsBase";

interface ILink {
  text: string;
  href: string;
}

interface ITestPageProps extends ReactComponentPropsBase {
  header?: string;
  links?: ILink[];
}

const TestPage = ({ header, links }: ITestPageProps) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="testPage">
      <h1>{header}</h1>
      {links && (
        <>
          <button onClick={() => setExpanded(!expanded)}>Expand links</button>
          {expanded && (
            <ul>
              {links.map((link, idx) => (
                <li key={idx}>
                  <a href={link.href}>{link.text}</a>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

export default TestPage;
